import { useContext } from 'react';
import { UserContext } from '../../auth/UserContext';
import { useMutationWithContext } from '../../hooks/useMutationWithContext';
import { failedToastMessage, successToastMessage } from '../../utils/commonUtils';
import { client, removeNote } from './notesGraphqlApi';

export const useDeleteNote = () => {
    const { activeOrganizationAccount } = useContext(UserContext);

    const [deleteMutation, { loading: isNoteDeleting }] = useMutationWithContext(removeNote, client);

    const deleteNote = ({ noteId }: { noteId: string }) =>
        deleteMutation({
            variables: {
                id: noteId
            },
            context: {
                headers: {
                    ownerId: activeOrganizationAccount
                }
            }
        })
            .then((res) => {
                if (res.data.deleteNote.errors) {
                    failedToastMessage('note.delete.errors');
                    return Promise.reject(res.data.deleteNote.errors);
                } else {
                    successToastMessage('note.delete.success');
                    return Promise.resolve(res.data.deleteNote.id);
                }
            })
            .catch((err) => {
                failedToastMessage('note.delete.errors');
                return Promise.reject(err);
            });

    return { deleteNote, isNoteDeleting };
};
